const limit =  1;

 export const  to64encode = (value: object) => {
  let text = JSON.stringify(value)
  for (let i = 0; i < limit; i++) {
    text = btoa(text);
  }
  return text;
}

export const to64decode = (value?: string | null) => {
  if(!value){
    return ''
  }
  try{
    for (let i = 0; i < limit; i++) {
      value = atob(value);
    }
    return JSON.parse(value);
  }catch(error: any){
    // console.log(error.message, value)
  }
}


export const to64DecodeSafe = (value?: string | null) => {
  if (!value) return null;

  try {
    let decoded = value;

    // Decodifica cada camada de base64
    for (let i = 0; i < limit; i++) {
      decoded = atob(decoded);
      console.log(`✅ [to64DecodeSafe] Camada ${i + 1} decodificada (len: ${decoded.length})`);
    }

    // Reverte encodeURIComponent para UTF-8 original
    const text = decodeURIComponent(decoded);
    console.log("🌐 [to64DecodeSafe] UTF-8 decodificado com sucesso");

    return JSON.parse(text);
  } catch (err) {
    console.error("❌ Erro no to64DecodeSafe:", err);
    return null;
  }
};


export const to64EncodeSafe = (value: object) => {
  try {
    let text = JSON.stringify(value);

    console.log("🔎 [to64EncodeSafe] Texto inicial:", text.slice(0, 200));

    // Remove caracteres de controle invisíveis
    text = text.replace(/[\u0000-\u001F\u007F]+/g, " ").replace(/\u200B/g, "");
    console.log("🧹 [to64EncodeSafe] Texto sanitizado:", text.slice(0, 200));

    // Converte para UTF-8 seguro para btoa
    const utf8Text = encodeURIComponent(text);
    console.log("🌐 [to64EncodeSafe] Texto UTF-8 (encodeURIComponent) gerado");

    // btoa
    let encoded = utf8Text;
    for (let i = 0; i < limit; i++) {
      encoded = btoa(encoded);
      console.log(`✅ [to64EncodeSafe] Camada ${i + 1} gerada (len: ${encoded.length})`);
    }

    return encoded;
  } catch (err) {
    console.error("❌ Erro no to64EncodeSafe:", err);
    throw err;
  }
};


